import { combineReducers } from 'redux';

import { userConstants } from '../constants';
import adminReducers from './admin.reducer';
import alertReducers from './alert.reducer';
import analyticsReducers from './analytics.reducer';
import ccassReducers from './ccass.reducer';
import dailypriceReducers from './dailyprice.reducer';
import miscReducers from './misc.reducer';
import preferenceReducers from './preference.reducer';
import signalReducers from './signal.reducer';
import stockReducers from './stock.reducer';
import stocklistReducers from './stocklist.reducer';
import tagReducers from './tag.reducer';
import tipsReducers from './tips.reducer';
import transactionReducers from './transaction.reducer';
import uiReducers from './ui.reducer';
import userReducers from './user.reducer';
import userExtReducers from './userExt.reducer';

const combinedReducer = combineReducers({
  admin: adminReducers,
  user: userReducers,
  userExt: userExtReducers,
  alert: alertReducers,
  transaction: transactionReducers,
  dailyprice: dailypriceReducers,
  signal: signalReducers,
  preference: preferenceReducers,
  ui: uiReducers,
  ccass: ccassReducers,
  stock: stockReducers,
  misc: miscReducers,
  stocklist: stocklistReducers,
  analytics: analyticsReducers,
  tag: tagReducers,
  tips: tipsReducers,
});

const rootReducer = (state, action) => {
  if (action.type === userConstants.LOGOUT) {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
